import React, { useState, useEffect, useRef, useContext } from "react";
import { toast } from "react-toastify";
import { CreateBotWithFilesUpload, CreateSimpleChatBot, CreateSkillStore } from "../../../services/skillStoreService";
import { useNavigate } from "react-router-dom";
import GenericDropdown from "../../../../../common/genericDropdown";
import SkillResources from "../skillResource";
import SkillLLMModels from "../skillModels";
import { getModelData, getDefaultModelConfig } from "../../../services/skillStoreService";
import { extractVariables } from "../../../../../../services/commonService"
import showMessage from "../../../../../common/message";
import AutoBotConfiguration from "../autoBotConfiguration";
import { v4 as uuidv4 } from 'uuid';
import loaderContext from "../../../../../../context/loader/loaderContext";
import { UserContext } from "../../../../../../context/user/userContext";
import { refreshToken } from "../../../../../../services/authService";
import { startTokenKeepAlive, stopTokenKeepAlive } from "../../../../../../utils/tokenKeepAlive";
import { sanitizeSearchResourceName } from "../../../../../../services/commonService";
const BOTConfiguration = (props) => {
  const {
    skillStoreForm,
    updateSkillStoreForm,
    handleUpdateSkill,
    validateFields,
    setShowBotConfiguration,
    setIsBackButtonClicked,
    botType,
    skillBotConfiguration,
    updateskillBotConfiguration
  } = props;
  const [initialFormState, setInitialFormState] = useState();
  const isInitialized = useRef(false);
  const [validationMessage, setValidationMessage] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState([]);
  const [resourceErrors, setResourceErrors] = useState([]);
  const [modelErrors, setModeErrors] = useState([]);
  const lastMessageCountRef = useRef(null);
  const inputRef = useRef(null);
  const chatGPTVersionRef = useRef(null);
  const chatbotUIViewRef = useRef(null);
  const curlRequestStringRef = useRef(null);
  const userAssistantMessageFormatRef = useRef(null);
  const [isWrapperAPIURL, setIsWrapperAPIURL] = useState(
    skillStoreForm?.IsUsingWrapperAPIURL
  );
  const [models, setModels] = useState([]);
  const wrapperURLRef = useRef(null);
  const fileRef = useRef(null);
  const outputRef = useRef(null);
  const BATCH_SIZE = 60;
  const MAX_PARALLEL_REQUESTS = 6; // tune (3–8) based on API capacity
  const { updateLoaderStatus } = useContext(loaderContext);
  const { getTokenDetails } = useContext(UserContext);
  useEffect(() => {
    setIsWrapperAPIURL(skillStoreForm?.IsUsingWrapperAPIURL);
  }, [skillStoreForm?.IsUsingWrapperAPIURL]);

  useEffect(() => {
    if (!isInitialized.current && skillStoreForm && skillStoreForm.Name) {
      setInitialFormState(JSON.parse(JSON.stringify(skillStoreForm)));
      isInitialized.current = true;
    }

  }, [skillStoreForm]);

  useEffect(() => {

    const getModels = async () => {
      const chatModels = await getModelData();
      setModels(chatModels);
    }
    const getDefaultConfig = async (modelName) => {
      updateLoaderStatus(true);
      const defaultConfig = await getDefaultModelConfig(modelName);
      // Do something with the default config, e.g., update form state
      if (defaultConfig?.modelInfo) {
        updateSkillStoreForm("CurlRequestString", defaultConfig?.modelInfo?.defaultCurlRequestString);
        updateSkillStoreForm("UserAssistantMessageFormat", defaultConfig?.modelInfo?.userAssistantMessageFormat);
        updateSkillStoreForm("WrapperAPIURL", defaultConfig?.modelInfo?.wrapperAPIURL);
        updateSkillStoreForm("ImageURL", defaultConfig?.modelInfo?.imageURL);
        updateSkillStoreForm("ImageParams", defaultConfig?.modelInfo?.imageParams);
        updateSkillStoreForm("CitationURL", defaultConfig?.modelInfo?.citationURL);
        updateSkillStoreForm("CitationParams", defaultConfig?.modelInfo?.citationParams);
        updateSkillStoreForm("IsUsingWrapperAPIURL", true);

        // Build DynamicProperties directly from the API response
        const updatedDynamicProperties = Object.entries(defaultConfig?.dynamicProperties || {}).map(
          ([key, value]) => {
            if (key === "$index_name") {
              const sanitized_name = sanitizeSearchResourceName(skillStoreForm.Name);
              return { key, Value: `${sanitized_name}-index` }; // adjust source field as needed
            }
            return { key, Value: value ?? "" };
          }
        );

        updateSkillStoreForm("DynamicProperties", updatedDynamicProperties);
        updateLoaderStatus(false);
      }
    }

    if (skillStoreForm) {
      getModels();
    }
    if (skillStoreForm && skillStoreForm.ChatGPTVersion === "") {
      updateSkillStoreForm("ChatGPTVersion", "gpt-4o");
    }

    // if (botType === "configure" && skillStoreForm) {
    //   getDefaultConfig(skillStoreForm.ChatGPTVersion === "" ? "gpt-4o" : skillStoreForm.ChatGPTVersion);
    // }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    updateSkillStoreForm(name, type === "checkbox" ? checked : value);
    if (name === "InputType") {
      updateSkillStoreForm("FileType", "");
      updateSkillStoreForm("OutputType", "");
    }
    if (name === "InputType") {
      inputRef.current.classList.remove("border-red");
    }
    if (name === "FileType") {
      fileRef.current.classList.remove("border-red");
    }
    if (name === "OutputType") {
      outputRef.current.classList.remove("border-red");
    }

    if (name === "ChatGPTVersion") {
      chatGPTVersionRef.current.classList.remove("border-red");
    }

    if (name === "UserAssistantMessageFormat") {
      userAssistantMessageFormatRef.current.classList.remove("border-red");
    }
  };

  const handleLastMessageCountChange = (e) => {
    const value = e.target.value;

    // Check if value exceeds 15 and set message
    if (value !== "" && Number(value) > 15) {
      // setValidationMessage("Maximum 15 value is allowed");
      lastMessageCountRef.current.focus();
      lastMessageCountRef.current.classList.add("border-red");
      toast.warn("Max value 15 is allowed");
    } else {
      setValidationMessage(""); // Clear message if valid
      updateSkillStoreForm("LastMessagesCount", value);
      lastMessageCountRef.current.classList.remove("border-red");
    }
  };

  const handleCitationURLChange = (e) => {
    const value = e.target.value;
    updateSkillStoreForm("CitationURL", value);
  };

  const handleCitationParamsChange = (e) => {
    const value = e.target.value;
    updateSkillStoreForm("CitationParams", value);
  };

  const handleImageURLChange = (e) => {
    const value = e.target.value;
    updateSkillStoreForm("ImageURL", value);
  };

  const handleImageParamsChange = (e) => {
    const value = e.target.value;
    updateSkillStoreForm("ImageParams", value);
  };

  const handleCurlChange = (e) => {
    const curlText = e.target.value;
    updateSkillStoreForm("CurlRequestString", curlText);

    // Extract variables from the updated cURL string
    const newVariableObjects = extractVariables(curlText); // [{ key: "$userId", Value: "" }, ...]

    // Create a map of existing DynamicProperties to preserve Values
    const existingPropertiesMap = skillStoreForm.DynamicProperties.reduce(
      (map, prop) => {
        map[prop.key] = prop.Value;
        return map;
      },
      {}
    );

    // Build the new DynamicProperties array, preserving Values where possible
    const updatedDynamicProperties = newVariableObjects.map((variableObj) => ({
      key: variableObj.key, // Use the 'key' property (e.g., "$userId")
      Value: existingPropertiesMap[variableObj.key] || "", // Preserve existing Value or use empty string
    }));

    // Update the state with the new DynamicProperties
    updateSkillStoreForm("DynamicProperties", updatedDynamicProperties);

    // Clear any related errors
    curlRequestStringRef.current.classList.remove("border-red");
    setErrors([]);
  };



  const handleVariableChange = (index, field, newValue) => {
    const updatedVariables = [...skillStoreForm.DynamicProperties];

    if (index >= 0 && index < updatedVariables.length) {
      updatedVariables[index] = { ...updatedVariables[index] };
      updatedVariables[index][field] = newValue;

      updateSkillStoreForm("DynamicProperties", updatedVariables);
    }

    const updatedErrors = [...errors];

    if (index >= 0 && index < updatedErrors.length) {
      updatedErrors[index] = { ...updatedErrors[index] };
      updatedErrors[index][field] = "";
      setErrors(updatedErrors);
    }
  };

  const addVariable = () => {
    updateSkillStoreForm("DynamicProperties", [
      ...skillStoreForm.DynamicProperties,
      { key: "", Value: "" },
    ]);
  };

  const removeVariable = (index) => {
    updateSkillStoreForm(
      "DynamicProperties",
      skillStoreForm.DynamicProperties.filter((_, i) => i !== index)
    );
    setErrors((prevState) => prevState.filter((_, i) => i !== index));
  };

  const isValidURL = (url) => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };

  const validateChatBotConfig = () => {
    let isValid = true;
    let newErrors = [];
    let newresourceErrors = [];

    if (skillStoreForm.InputType === "") {
      inputRef.current.classList.add("border-red");
      inputRef.current.focus();
      toast.error("Input Type is required");
      return false;
    }

    if (
      skillStoreForm.InputType !== "" &&
      isShowFileType() &&
      skillStoreForm.FileType === ""
    ) {
      fileRef.current.classList.add("border-red");
      fileRef.current.focus();
      toast.error("File Type is required");
      return false;
    }

    if (
      skillStoreForm.InputType !== "" &&
      skillStoreForm.InputType === "file" &&
      skillStoreForm.OutputType === ""
    ) {
      outputRef.current.classList.add("border-red");
      outputRef.current.focus();
      toast.error("Output Type is required");
      return false;
    }

    if (skillStoreForm.LastMessagesCount === "") {
      lastMessageCountRef.current.classList.add("border-red");
      lastMessageCountRef.current.focus();
      toast.error("Last Message Count is required");
      return false;
    }
    if (skillStoreForm.ChatGPTVersion === "") {
      chatGPTVersionRef.current.classList.add("border-red");
      chatGPTVersionRef.current.focus();
      toast.error("Chat GPT Version is required");
      return false;
    }

    if (
      skillStoreForm?.IsUsingWrapperAPIURL &&
      skillStoreForm.WrapperAPIURL === ""
    ) {
      wrapperURLRef.current.classList.add("border-red");
      toast.error("Wrapper API URL is required");
      wrapperURLRef.current.focus();
      return false;
    }

    if (
      skillStoreForm?.IsUsingWrapperAPIURL &&
      !isValidURL(skillStoreForm.WrapperAPIURL)
    ) {
      wrapperURLRef.current.classList.add("border-red");
      toast.error("Wrapper API URL entered is invalid");
      wrapperURLRef.current.focus();
      return false;
    }

    if (skillStoreForm.CurlRequestString === "") {
      curlRequestStringRef.current.classList.add("border-red");
      curlRequestStringRef.current.focus();
      toast.error("Curl Request String is required");
      return false;
    }

    if (skillStoreForm.UserAssistantMessageFormat === "") {
      userAssistantMessageFormatRef.current.classList.add("border-red");
      userAssistantMessageFormatRef.current.focus();
      toast.error("User Assistant Message Format is required");
      return false;
    }

    skillStoreForm.DynamicProperties.forEach((item, index) => {
      if (!item.key || !item.key.includes("$")) {
        isValid = false;
        newErrors[index] = {
          ...newErrors[index],
          key: "Key must contain '$' and not be empty",
        };
      }

      if (!item.key.trim()) {
        isValid = false;
        newErrors[index] = {
          ...newErrors[index],
          key: "Key is required.",
        };
      } else if (!item.key.includes("$") || item.key.trim() === "$") {
        isValid = false;
        newErrors[index] = {
          ...newErrors[index],
          key: "Key must contain '$' followed by text.",
        };
      }

      if (!item.Value) {
        isValid = false;
        newErrors[index] = {
          ...newErrors[index],
          Value: "Value cannot be empty",
        };
      }
    });

    const seenResourceIds = new Set();
    const seenResourceNames = new Set();
    skillStoreForm.SkillResources.forEach((item, index) => {
      if (!item.ResourceId.trim()) {
        isValid = false;
        newresourceErrors[index] = {
          ...newresourceErrors[index],
          ResourceId: "Resource Id is required.",
        };
      } else if (seenResourceIds.has(item.ResourceId.trim())) {
        isValid = false;
        newresourceErrors[index] = {
          ...newresourceErrors[index],
          ResourceId: "Duplicate Resource Id.",
        };
      } else {
        seenResourceIds.add(item.ResourceId.trim());
      }

      if (!item.ResourceName) {
        isValid = false;
        newresourceErrors[index] = {
          ...newresourceErrors[index],
          ResourceName: "Recource Name is required.",
        };
      } else if (seenResourceNames.has(item.ResourceName.trim())) {
        isValid = false;
        newresourceErrors[index] = {
          ...newresourceErrors[index],
          ResourceName: "Duplicate Resource Name.",
        };
      } else {
        seenResourceNames.add(item.ResourceName.trim());
      }
    });

    setErrors(newErrors);
    setResourceErrors(newresourceErrors);
    return isValid;
  };

  // const validateSkillLLMModels = () => {
  //   let isValid = true;
  //   const newModelErrors = [];
  //   let hasDuplicateModel = false;

  //   const modelIdMap = {};

  //   skillStoreForm.SkillModels?.forEach((model, index) => {
  //     const modelId = model.ModelId;

  //     if (modelId && modelId !== "default" && modelId !== "-1") {
  //       if (!modelIdMap[modelId]) {
  //         modelIdMap[modelId] = [];
  //       }
  //       modelIdMap[modelId].push(index);
  //     }
  //   });

  //   if (skillStoreForm.SkillModels?.length > 0) {
  //     skillStoreForm.SkillModels.forEach((model, modelIndex) => {
  //       const errors = {};

  //       if (!model.ModelId || model.ModelId === "default" || model.ModelId === "-1") {
  //         errors.ModelId = "Model is required";
  //         isValid = false;
  //       } else if (modelIdMap[model.ModelId]?.length > 1) {
  //         errors.ModelId = "Duplicate Model is not allowed";
  //         hasDuplicateModel = true;
  //         isValid = false;
  //       }

  //       if (!model.CurlRequestString?.trim()) {
  //         errors.CurlRequestString = "Curl Request is required";
  //         isValid = false;
  //       }

  //       if (!model.UserAssistantMessageFormat?.trim()) {
  //         errors.UserAssistantMessageFormat =
  //           "Assistant Message Format is required";
  //         isValid = false;
  //       }

  //       // Dynamic Properties validation
  //       const dynamicErrors = [];
  //       if (model.DynamicProperties?.length > 0) {
  //         model.DynamicProperties?.forEach((prop, propIndex) => {
  //           const propError = {};

  //           if (!prop.key?.trim()) {
  //             propError.key = "Key is required";
  //             isValid = false;
  //           } else if (!prop.key.includes("$")) {
  //             propError.key = "Key must contain '$'";
  //             isValid = false;
  //           }

  //           if (!prop.Value?.trim()) {
  //             propError.Value = "Value is required";
  //             isValid = false;
  //           }

  //           if (Object.keys(propError).length > 0) {
  //             dynamicErrors[propIndex] = propError;
  //           }
  //         });


  //       }
  //       if (dynamicErrors.length > 0) {
  //         errors.DynamicProperties = dynamicErrors;
  //       }

  //       if (Object.keys(errors).length > 0) {
  //         newModelErrors[modelIndex] = errors;
  //       }
  //     });
  //   }
  //   if (hasDuplicateModel)
  //     showMessage("Duplicate Model is not allowed", -2);

  //   setModeErrors(newModelErrors);
  //   return isValid;
  // };

  const validateSkillLLMModels = () => {
    let isValid = true;
    const newModelErrors = [];
    let hasDuplicateModel = false;

    const isEmptyModel = (id) =>
      id === undefined || id === null || id === "" || id === "default" || id === "-1" || id === -1;

    // Trim + lowercase so "GPT-4o " and "gpt-4o" compare equal
    const normalize = (value) => String(value ?? "").trim().toLowerCase();

    const chatGPTVersion = normalize(skillStoreForm.ChatGPTVersion);

    // Find the ChatGPTVersion text in the complete models list and get its Id
    const chatGPTModelId = chatGPTVersion
      ? models?.find((m) => normalize(m.Name) === chatGPTVersion)?.Id
      : undefined;

    const modelIdMap = {};

    skillStoreForm.SkillModels?.forEach((model, index) => {
      if (!isEmptyModel(model.ModelId)) {
        const modelId = String(model.ModelId);
        if (!modelIdMap[modelId]) {
          modelIdMap[modelId] = [];
        }
        modelIdMap[modelId].push(index);
      }
    });
    if (skillStoreForm.SkillModels?.length > 0) {
      skillStoreForm.SkillModels.forEach((model, modelIndex) => {
        const errors = {};

        if (isEmptyModel(model.ModelId)) {
          errors.ModelId = "Model is required";
          isValid = false;
        } else if (modelIdMap[String(model.ModelId)]?.length > 1) {
          errors.ModelId = "Duplicate Model is not allowed";
          hasDuplicateModel = true;
          isValid = false;
        } else if (
          chatGPTModelId !== undefined &&
          String(model.ModelId) === String(chatGPTModelId)
        ) {
          // Model is the same as the selected ChatGPT Version
          errors.ModelId = "Model cannot be the same as the selected ChatGPT Version";
          hasDuplicateModel = true;
          isValid = false;
        }

        // ... rest of your validation (CurlRequestString, UserAssistantMessageFormat,
        // DynamicProperties) stays exactly as it is ...

        if (Object.keys(errors).length > 0) {
          newModelErrors[modelIndex] = errors;
        }
      });
    }

    if (hasDuplicateModel) showMessage("Duplicate Model is not allowed", -2);

    setModeErrors(newModelErrors);
    return isValid;
  };

  const handleCreateSkill = () => {
    if (
      validateChatBotConfig() &&
      validateSkillLLMModels()
      && (botType !== "configure" || validateChatBotConfig)//validateConfigurationFields())
    ) {
      CreateSkillStore(skillStoreForm).then(async (res) => {
        if (res?.Status === "Skill Created Successfully.") {
          toast.success(res?.Status);
          if (botType === "configure") {
            updateskillBotConfiguration("SkillStoreId", res?.SkillStoreId);
            updateLoaderStatus(true);
            if (skillBotConfiguration.PDFWithImages === true || skillBotConfiguration.PDFWithText === true)
              await uploadFiles(res?.SkillStoreId);
            if (skillBotConfiguration.SimpleChatBot === true) {
              const formData = new FormData();
              formData.append("bot_config", skillBotConfiguration ? JSON.stringify(skillBotConfiguration) : "{}");
              formData.append("skill_store_id", res?.SkillStoreId);
              await CreateSimpleChatBot(formData);
              toast.info(
                "Bot creation is in progress. Please allow some time for the files to be processed."
              );
            }
            updateLoaderStatus(false);
            navigate("/skillstore");
          }
          else {
            navigate("/skillstore");
          }
        } else {
          toast.error("Unable to Create skill");
        }
        //
      });
    }
  };

  const uploadBatch = async ({
    batch,
    containerName,
    uploadId,
    batchNo,
    totalBatches,
    skillStoreId,
    skillName
  }) => {
    const formData = new FormData();
    formData.append("container_name", containerName);
    formData.append("bot_name", skillName);
    formData.append("upload_id", uploadId);
    formData.append("batch_no", String(batchNo));
    formData.append("total_batches", String(totalBatches));
    formData.append("bot_config", skillBotConfiguration ? JSON.stringify(skillBotConfiguration) : "{}");
    formData.append("skill_store_id", skillStoreId);

    batch.forEach((file) => formData.append("files", file));

    await CreateBotWithFilesUpload(formData);
  };

  // Simple concurrency runner
  const runWithConcurrency = async (tasks, limit) => {
    const results = [];
    let i = 0;

    const workers = Array.from({ length: limit }, async () => {
      while (i < tasks.length) {
        const taskIndex = i++;
        results[taskIndex] = await tasks[taskIndex]();
      }
    });

    await Promise.all(workers);
    return results;
  };

  const uploadFiles = async (skillStoreId) => {
    try {
      await startTokenKeepAlive(
        getTokenDetails,
        refreshToken
      );
      updateLoaderStatus(true);

      const containerName = `pdf-container-${Date.now()}`;
      const uploadId = uuidv4();

      const totalBatches = Math.ceil(skillBotConfiguration.Files.length / BATCH_SIZE);

      const tasks = [];
      for (let i = 0; i < skillBotConfiguration.Files.length; i += BATCH_SIZE) {
        const batch = skillBotConfiguration.Files.slice(i, i + BATCH_SIZE);
        const batchNo = Math.floor(i / BATCH_SIZE) + 1;
        const sanitized_name = sanitizeSearchResourceName(skillStoreForm.Name);
        tasks.push(() =>
          uploadBatch({
            batch,
            containerName,
            uploadId,
            batchNo,
            totalBatches,
            skillStoreId,
            skillName: sanitized_name
          })
        );
      }

      // Fire all requests (queued to API) with limited parallelism
      await runWithConcurrency(tasks, MAX_PARALLEL_REQUESTS);

      toast.info(
        "Bot creation is in progress. Please allow some time for the files to be processed."
      );
    } catch (error) {
      // console.error(error);
      updateLoaderStatus(false);
      toast.error("Queueing upload failed");
    } finally {
      stopTokenKeepAlive();
      updateLoaderStatus(false);

    }
  };

  const validateConfigurationFields = () => {
    let isValid = true;
    if (skillBotConfiguration.SimpleChatBot === false && skillBotConfiguration.PDFWithImages === false && skillBotConfiguration.PDFWithText === false) {
      toast.error("Please select type of bot that needs to be configured");
      isValid = false;
    }

    if (
      skillBotConfiguration.PDFWithImages === true || skillBotConfiguration.PDFWithText === true
    ) {
      if (skillBotConfiguration.Files.length === 0) {
        toast.error("Please upload PDF files to proceed with bot configuration");
        isValid = false;
      }

    }
    return isValid;
  }

  const isFormChanged = () => {
    return JSON.stringify(skillStoreForm) !== JSON.stringify(initialFormState);
  };

  const handleUpdateSkillAndBot = () => {
    if (validateFields() && validateChatBotConfig() && validateSkillLLMModels()
    ) {
      handleUpdateSkill();
    }
  };

  const allFileTypes = [
    { Id: "Excel", Name: "Excel(XLSX)" },
    { Id: "HTML", Name: "HTML" },
    {
      Id: "Image",
      Name: "Images(JPEG/JPG, PNG, WEBP)",
    },
    { Id: "PDF", Name: "PDF" },
    { Id: "PowerPoint", Name: "PowerPoint(PPTX)" },
    //{ Id: "TIFF", Name: "TIFF" },
    { Id: "Word", Name: "Word(DOCX)" },
  ];

  const filteredDropdownData = (inputType) => {
    return allFileTypes.filter((item) =>
      inputType === "file" ? item.Id === "PDF" : true
    );
  };

  const isShowFileType = () => {
    if (skillStoreForm.InputType?.toLowerCase() === "file") {
      return true;
    } else if (
      skillStoreForm.InputType?.toLowerCase() === "file,text" ||
      skillStoreForm.InputType?.toLowerCase() === "text,file"
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="bot-configuration skill-fullwidth">
      <div className="dash-section p20">
        <h2 className="h2">BOT Configuration</h2>
        <div className="form-group">
          <div className="form-config-box">
            <label>
              Input Type <span className="red">*</span>{" "}
            </label>
            <GenericDropdown
              dropdownData={[
                { Id: "text", Name: "Text" },
                { Id: "file", Name: "File" },
              ]}
              selectedValue={skillStoreForm.InputType?.toLowerCase()}
              onDropdownSelection={(value) =>
                handleChange({ target: { name: "InputType", value } })
              }
              title="Select Input Type"
              genericRef={inputRef}
            ></GenericDropdown>
          </div>
          <div
            className={
              skillStoreForm.InputType?.toLowerCase() !== "text" &&
                skillStoreForm.InputType?.toLowerCase() !== ""
                ? "form-config-box"
                : "form-config-box disabled-element"
            }
          >
            <div
              className={
                skillStoreForm.InputType?.toLowerCase() !== "text" &&
                  skillStoreForm.InputType?.toLowerCase() !== ""
                  ? ""
                  : "disabled-div"
              }
            >
              <label>
                {" "}
                File Type {isShowFileType() && (
                  <span className="red">*</span>
                )}{" "}
              </label>
              <GenericDropdown
                dropdownData={filteredDropdownData(
                  skillStoreForm.InputType?.toLowerCase()
                )}
                selectedValue={skillStoreForm.FileType}
                onDropdownSelection={(value) =>
                  handleChange({ target: { name: "FileType", value } })
                }
                title="Select File Type"
                genericRef={fileRef}
              ></GenericDropdown>
            </div>
          </div>
          <div
            className={
              skillStoreForm.InputType?.toLowerCase() !== "text" &&
                skillStoreForm.InputType?.toLowerCase() === "file"
                ? "form-config-box"
                : "form-config-box disabled-element"
            }
          >
            <div
              className={
                skillStoreForm.InputType?.toLowerCase() !== "text" &&
                  skillStoreForm.InputType?.toLowerCase() === "file"
                  ? ""
                  : "disabled-div"
              }
            >
              <label>
                {" "}
                Output Type{" "}
                {skillStoreForm.InputType?.toLowerCase() === "file" && (
                  <span className="red">*</span>
                )}{" "}
              </label>
              <GenericDropdown
                dropdownData={[{ Id: "Excel", Name: "Excel" }]}
                selectedValue={skillStoreForm.OutputType}
                onDropdownSelection={(value) =>
                  handleChange({ target: { name: "OutputType", value } })
                }
                title="Select Output Type"
                genericRef={outputRef}
              ></GenericDropdown>
            </div>
          </div>

          <div className="form-config-box">
            <label>
              Last Message Count <span className="red">*</span>{" "}
            </label>
            <input
              type="text"
              name="LastMessagesCount"
              min="0"
              max="15"
              value={skillStoreForm.LastMessagesCount}
              onChange={handleLastMessageCountChange}
              ref={lastMessageCountRef}
              className="prompt-text"
            />
          </div>
          {validationMessage && (
            <span style={{ color: "red", fontSize: "12px", marginLeft: "5px" }}>
              {validationMessage}
            </span>
          )}
          <div className="form-config-box">
            <label>
              ChatGPT Version <span className="red">*</span>{" "}
            </label>
            <input
              type="text"
              className="prompt-text"
              name="ChatGPTVersion"
              maxLength={20}
              value={skillStoreForm.ChatGPTVersion === null || skillStoreForm.ChatGPTVersion === undefined || skillStoreForm.ChatGPTVersion === "" ? "gpt-4o" : skillStoreForm.ChatGPTVersion}
              value={skillStoreForm.ChatGPTVersion}
              onChange={handleChange}
              disabled={true}
              ref={chatGPTVersionRef}
            />
          </div>
          <div className="form-config-box">
            <label>Chatbot UI View</label>
            <input
              type="text"
              maxLength={20}
              name="ChatbotUIView"
              className="prompt-text"
              value={skillStoreForm.ChatbotUIView}
              ref={chatbotUIViewRef}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div className="dash-section p20">
        <div className="form-group">
          <div className="form-config-box">
            <label>Citation URL </label>
            <input
              type="text"
              name="CitationURL"
              value={skillStoreForm.CitationURL}
              onChange={handleCitationURLChange}
              className="prompt-text"
            />
          </div>

          <div className="form-config-box">
            <label>Citation Params </label>
            <input
              type="text"
              name="CitationParams"
              value={skillStoreForm.CitationParams}
              onChange={handleCitationParamsChange}
              className="prompt-text"
            />
          </div>
        </div>
        <div className="form-group">
          <div className="form-config-box">
            <label>Image URL </label>
            <input
              type="text"
              name="ImageURL"
              value={skillStoreForm.ImageURL}
              onChange={handleImageURLChange}
              className="prompt-text"
            />
          </div>
          <div className="form-config-box">
            <label>Image Params </label>
            <input
              type="text"
              name="ImageParams"
              value={skillStoreForm.ImageParams}
              onChange={handleImageParamsChange}
              className="prompt-text"
            />
          </div>
        </div>
      </div>

      <div className="dash-section p20">
        <div className="form-group checkbox-row">
          <div className="form-config-box-check">
            <input
              type="checkbox"
              name="IsChatbotTestable"
              checked={skillStoreForm.IsChatbotTestable}
              onChange={handleChange}
            />
            <div> Is Chatbot Testable </div>
          </div>
          <div className="form-config-box-check">
            <input
              type="checkbox"
              name="ShowCitation"
              checked={skillStoreForm.ShowCitation}
              onChange={handleChange}
            />
            <div>Show Citation </div>
          </div>
          <div className="form-config-box-check">
            <input
              type="checkbox"
              name="ShowFollowUpQuestions"
              checked={skillStoreForm.ShowFollowUpQuestions}
              onChange={handleChange}
            />
            <div>Show Follow Up Question </div>
          </div>
        </div>
      </div>

      <div className="dash-section p20">
        <div className="skill-one-row">
          <div className="check-ackn wrapper-api-url">
            <label className="check-contain">
              <input
                type="checkbox"
                checked={skillStoreForm?.IsUsingWrapperAPIURL}
                className="p-checkbox"
                onChange={() => {
                  setIsWrapperAPIURL(!skillStoreForm?.IsUsingWrapperAPIURL);
                  updateSkillStoreForm(
                    "IsUsingWrapperAPIURL",
                    !skillStoreForm?.IsUsingWrapperAPIURL
                  );
                  updateSkillStoreForm("WrapperAPIURL", "");
                }}
              />
              <span className="checkmark-check"></span>
            </label>
            <p>Is Using Wrapper API URL </p>
          </div>
          {isWrapperAPIURL && (
            <div className="prompt-title-wrap">
              <input
                maxLength={500}
                type="textbox"
                placeholder="Wrapper URL"
                className="prompt-text"
                value={skillStoreForm?.WrapperAPIURL}
                onInput={(e) => {
                  updateSkillStoreForm("WrapperAPIURL", e.target.value);
                  wrapperURLRef.current.classList.remove("border-red");
                }}
                ref={wrapperURLRef}
              />
            </div>
          )}
        </div>
      </div>
      <div className="dash-section p20">
        <div className="form-group">
          <div className="form-config-box">
            <label>
              Curl Request <span className="red">*</span>{" "}
            </label>
            <textarea
              name="CurlRequestString"
              rows="4"
              value={skillStoreForm.CurlRequestString}
              onChange={handleCurlChange}
              className="prompt-text"
              ref={curlRequestStringRef}
            />
          </div>
          <div className="form-config-box">
            <label>
              User Assistant Message Format <span className="red">*</span>{" "}
            </label>
            <textarea
              name="UserAssistantMessageFormat"
              rows="4"
              value={skillStoreForm.UserAssistantMessageFormat}
              onChange={handleChange}
              className="prompt-text"
              ref={userAssistantMessageFormatRef}
            />
          </div>
        </div>

        {skillStoreForm?.DynamicProperties?.length > 0 && (
          <div className="all-variavle-inputs">
            {skillStoreForm?.DynamicProperties?.map((item, index) => (
              <div key={index} className="variable-input">
                <div className="input-wrapper">
                  <input
                    type="text"
                    placeholder="Key"
                    value={item.key}
                    onChange={(e) =>
                      handleVariableChange(index, "key", e.target.value)
                    }
                    className={errors[index]?.key ? "error-border" : ""}
                  />
                  {errors[index]?.key && (
                    <span className="error-text">{errors[index].key}</span>
                  )}
                </div>
                <div className="input-wrapper">
                  <input
                    type="text"
                    placeholder="Value"
                    value={item.Value}
                    onChange={(e) =>
                      handleVariableChange(index, "Value", e.target.value)
                    }
                    className={errors[index]?.value ? "error-border" : ""}
                  />
                  {errors[index]?.Value && (
                    <span className="error-text">{errors[index].Value}</span>
                  )}
                </div>
                <div className="button-wrap-row">
                  <button className="" onClick={() => removeVariable(index)}>
                    <div className="minus-icon-white"></div>
                  </button>
                  {index === skillStoreForm.DynamicProperties?.length - 1 && (
                    <button className="" onClick={addVariable}>
                      <div className="plus-icon-white-bot"></div>
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="dash-section p20">

        {botType !== "configure" ? (
          <>
            <SkillResources
              skillStoreForm={skillStoreForm}
              updateSkillStoreForm={updateSkillStoreForm}
              resourceErrors={resourceErrors}
            ></SkillResources>
            <SkillLLMModels
              skillStoreForm={skillStoreForm}
              updateSkillStoreForm={updateSkillStoreForm}
              modelErrors={modelErrors}
              models={models}
              setModeErrors={setModeErrors}
            ></SkillLLMModels>
          </>
        )

          : (
            <>
              <AutoBotConfiguration skillBotConfiguration={skillBotConfiguration} updateskillBotConfiguration={updateskillBotConfiguration}></AutoBotConfiguration>

            </>
          )}

        <div className="prompt-button-wrapper">
          {handleUpdateSkill === undefined && (
            <button
              className="backbtn"
              onClick={() => {
                setShowBotConfiguration(false);
                setIsBackButtonClicked(true);
              }}
            >
              Back
            </button>
          )}
          {handleUpdateSkill !== undefined && (
            <button
              className="cancel-btn"
              onClick={() => {
                navigate("/skillstore");
              }}
            >
              Cancel
            </button>
          )}
          {handleUpdateSkill !== undefined && <div></div>}
          <div
            className={
              isFormChanged()
                ? "prompt-button-wrapper"
                : "prompt-button-wrapper disabled-element"
            }
          >
            <div></div>
            {handleUpdateSkill === undefined && (
              <button
                className="btn-save-bot genrate-btn"
                onClick={handleCreateSkill}
              >
                Save Bot
              </button>
            )}
            {handleUpdateSkill !== undefined && (
              <button
                className="btn-save-bot genrate-btn"
                onClick={handleUpdateSkillAndBot}
                disabled={!isFormChanged()}
              >
                Update Bot
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BOTConfiguration;
